export class CardPopUpProperties {
  portfolioPerformance = {
    total: new CardProps(true),
    unrealized: new CardProps(),
    realized: new CardProps(),
  };

  netFundPerformance = {
    beforeCarry: new CardProps(),
    afterCarry: new CardProps(),
  };
}

class CardProps {
  constructor(
    public value: boolean = false,
    public isModalDisplayed: boolean = false,
  ) {}
}
